<template>
  <div>
    <CommentForm
      :user="user"
      :entityId="entityId"
      :entityType="entityType"
      @comment-created="commentCreated"
    />

    <div class="mt-5 comment-list text-left">
      <CommentCard
        v-for="comment in comments" :key="comment.id"
        :comment="comment"
        :isAuthor="isAuthor"
        @comment-deleted="commentDeleted"
        @reply-created="commentReplyCreated"
        @reply-deleted="commentReplyDeleted"
        @favorite-toggled="commentFavoriteToggled"
      />

      <div class="mt-5">
        <Button
          class="btn btn-primary w-100 font-size-xSmall"
          @click="loadMoreComments"
          :loading="parentCommentsLoader"
          v-if="isLoadMoreParentCommentsVisible && comments.length > 0"
        >
          Carregar mais comentários
        </Button>
      </div>

    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import CommentsService from '@/modules/comments/services/comments-service'

import Button from '@/components/common/Button/Button'
import CommentCard from '@/components/comment/CommentCard'
import CommentForm from '@/components/comment/CommentForm'

export default {
  name: 'CommentSection',
  props: ['entityId', 'entityType', 'isAuthor'],
  components: {
    Button,
    CommentCard,
    CommentForm
  },
  data () {
    return {
      comments: [],
      commentsPage: 1,
      parentCommentsLoader: false,
      isLoadMoreParentCommentsVisible: true
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    ...mapState('auth', {
      authenticated: state => state.authenticated
    })
  },
  created () {
    this.getComments()
  },
  methods: {
    async getComments (parentId = null, page = 1) {
      try {
        const variables = {
          entityId: this.entityId,
          modelType: this.entityType,
          parentId: parentId,
          page: page
        }
        const comments = await CommentsService.getComments(variables)
        this.comments = [...this.comments, ...comments]
        this.isLoadMoreParentCommentsVisible = comments.length > 0
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
    },
    async loadMoreComments () {
      this.parentCommentsLoader = true
      this.commentsPage++
      await this.getComments(null, this.commentsPage)
      this.parentCommentsLoader = false
    },
    commentCreated (comment) {
      this.comments = [comment, ...this.comments]
    },
    commentDeleted (comment) {
      const index = this.comments.findIndex(c => c.id === comment.id)
      this.comments.splice(index, 1)
    },
    commentReplyCreated (reply) {
      // Refresh parent comment on reply
      if (reply.parent) {
        this.refreshComment(reply.parent)
      }
    },
    commentReplyDeleted (reply) {
      if (reply.parent) {
        this.refreshComment(reply.parent)
      }
    },
    async refreshComment (id) {
      const index = this.comments.findIndex(c => c.id === id)
      const comment = await CommentsService.getComment(id)
      this.comments.splice(index, 1, comment)
    },
    commentFavoriteToggled (comment) {
      this.refreshComment(comment.id)
    }
  }
}
</script>

<style lang="scss" scoped></style>
